import { memo } from "react";
import Col from "react-bootstrap/Col";

// The website description for logo is a separate component
const LogoDescription = ({ xs, sm, lg, fullName, jobPosition }) => {
  return (
    <>
      <Col xs={xs} sm={sm} lg={lg} className="d-flex flex-column justify-content-center align-items-start text-light">
        <h2 className="mb-0">
          <b>{fullName}</b>
        </h2>
        <h6>{jobPosition}</h6>
      </Col>
    </>
  );
};

export default memo(LogoDescription);
